import BaseModal from './BaseModal';
import kidsAccessModalTpl from 'templates/modals/__kidsAccessModal.tpl';
import errorTpl from 'templates/modals/__errorModal.tpl';
import { getLocale } from 'services/LocalizationService';
import HttpService from 'services/HttpService';
import ProfileService from 'services/ProfileService';
import KidsAccessTrackingService from 'services/KidsAccessTrackingService';

export default class KidsAccessModal extends BaseModal {
    static CREATED = false;

    constructor(data) {
        super(kidsAccessModalTpl({ getLocale, data }));
        this.data = data;
        this.profileService = new ProfileService();
        this.http = new HttpService();
        this.errorTpl = errorTpl({ getLocale });
        this.tracking = new KidsAccessTrackingService();
        this.token = '';

        let jsvarContainer = document.querySelector('#user-profiles-js-var');
        if (jsvarContainer) {
            const rawPhpVar = JSON.parse(jsvarContainer.innerHTML);

            if (rawPhpVar.token) {
                this.token = rawPhpVar.token;
            }
        }
    }

    show() {
        if (!KidsAccessModal.CREATED) {
            super.show();
            document.querySelector('body').style.overflow = 'hidden';

            setTimeout(() => {
                this.me.classList.add('show');
                this.tracking.trackModalDisplay();
            }, 50);

            KidsAccessModal.CREATED = true;
        }
    }

    close() {
        this.me.classList.remove('show');
        this.tracking.trackModalClose();
        setTimeout(() => {
            super.close();
            KidsAccessModal.CREATED = false;
        }, 500);

        document.querySelector('body').style.overflow = 'auto';
    }

    reset() {
        let temp = document.createElement('div');
        temp.innerHTML = this.template;

        const div = temp.querySelector('.modal__wrapper');
        document.querySelector('#kids-access').innerHTML = div.outerHTML;
        this.bindEvents();
    }

    createKidsProfile() {
        return this.http.doPost('/xhr/kids-create/', { tk_trp: this.token });
    }

    bindEvents() {
        super.bindEvents();
        const self = this;
        const addProfile = document.getElementById('cta1');
        const customizeProfile = document.getElementById('cta2');

        addProfile.addEventListener('click', () => {
            self.tracking.trackCtaClick(self.data.call_to_action_1 ?? 'Start Browsing');
            self.createKidsProfile()
                .then(() => {
                    window.location.pathname = '/';
                })
                .catch(() => {
                    self.showErrorMessage();
                });
        });

        customizeProfile.addEventListener('click', () => {
            self.tracking.trackCtaClick(self.data.call_to_action_2 ?? 'Customize Profile');
            window.location.href = '/user-profile/create-kid/?flow=kids-access';
        });
    }

    showErrorMessage() {
        if (this.me === null) {
            return;
        }

        let self = this;

        let temp = document.createElement('div');
        temp.innerHTML = this.errorTpl;

        const div = temp.querySelector('.modal__wrapper');
        const modal = document.querySelector('#kids-access');
        modal.innerHTML = div.outerHTML;

        modal.querySelector('#cta1').addEventListener('click', () => {
            self.reset();
        });
    }

    static async create() {
        const http = new HttpService();
        const pageAttributeUrl = `${CBS.Registry.region.prefix}/xhr/kids-access/`;
        try {
            const pageAttributes = await http.doGet(pageAttributeUrl);
            return new KidsAccessModal(pageAttributes.data.data);
        } catch {
            return null;
        }
    }

    static getTrackingVars(e) {
        let element = e.currentTarget;
        let subMenu = element.closest('ul');
        let row = 0;

        if (subMenu) {
            row =
                Array.prototype.slice
                    .call(subMenu.querySelectorAll('li'))
                    .findIndex((item) => item === element) + 1;
        }

        let col = document.querySelectorAll('.header__nav .siteLogo').length;
        col += document.querySelectorAll(
            '.header__nav > ul > li > a, .header__nav > ul > li > div',
        ).length;

        return {
            posRowNum: row.toString(),
            posColNum: col.toString(),
            menuOrientation: 'header',
        };
    }
}
